
  
  
  import FETCHING from '../../library/fetching'
  import DATA_MASTER from '../../library/dataMaster'
  import UMUM from '../../library/umum'
  
  export default {
    data() {
      return {
  
        form : {
          id : '',
          master_kategori : '',
          uraian : '',
          unit_kerja : '',
          unit_kerja_uraian : '',
          pengoreksi : '',
          keterangan : '',
          status_koreksi : null,
          status_harmonisasi : null,
          status : '',
        },





        lampiran : {
          id : '',
          uraian : '',
          file : null,
          fileRef : '',
          uraian : '',
          status : 1,
          
          file_id : '',
          file_status : '',
          file_keterangan : '',
          file_correction : '',

          keterangan : '',

          date_usulan : '',

          pengoreksi : '',
          status_koreksi : '',
          date_koreksi : '',

          harmonisuser : '',
          status_harmonisasi : '',
          date_harmonisasi : '',




          pengusul_nama : '',
          pengusul_gelar_belakang : '',
          pengusul_gelar_depan : '',
          pengusul_nip : '',

          pengoreksi_nama : '',
          pengoreksi_gelar_belakang : '',
          pengoreksi_gelar_depan : '',
          pengoreksi_nip : '',

          harmonisasi_nama : '',
          harmonisasi_gelar_belakang : '',
          harmonisasi_gelar_depan : '',
          harmonisasi_nip : '',


        },


        filterku : {
          instansi : '',
          unit_kerja : '',
          fileStat : false,
        },
      

        // ====================================== CONTOH AUTOCOMPLETE ====================================
        autocomplete_db : '',
        // ====================================== CONTOH AUTOCOMPLETE ====================================
       
        list_data : [],
        // list_lampiran : [],
  
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,
  
  
        mdl_lihat: false,
        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_add_lampiran : false,
        mdl_lihat_lampiran : false,
        mdl_hapus_lampiran : false,
        mdl_keterangan_lampiran : false,
        mdl_lihat_lampiran_koreksi : false,
        btn_add: false,

        fileOld : '',
  
  
        FETCHING : FETCHING,
        DATA_MASTER : DATA_MASTER,
        UMUM : UMUM,
      }
    },
    methods: {
  
  
      getView : function(){
        this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_jdih_usulan + "viewData", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value,

                verifikasi : false,
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                this.$store.commit("hideLoading");
                console.log(res_data);
        });
      },
  
      addData : function(number) {
        fetch(this.$store.state.url.URL_jdih_usulan + "addData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });
      },
  
      editData : function(data){

        this.form.status = data

        fetch(this.$store.state.url.URL_jdih_usulan + "editData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        }).then(res_data => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getView();
            this.mdl_edit = false
        });
      },
  
      removeData : function(E){
        fetch(this.$store.state.url.URL_jdih_usulan + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : this.form.id})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            this.getView();
        });
  
      },
  
      selectData : function(data){

          this.form.id = data.id ;
          this.form.master_kategori = data.master_kategori ;
          this.form.uraian = data.uraian ;
          this.form.pengoreksi = data.pengoreksi ;
          this.form.keterangan = data.keterangan ;
          this.form.status = data.status ;
          this.form.status_koreksi = data.status_koreksi ;
          this.form.status_harmonisasi = data.status_harmonisasi ;
          this.form.unit_kerja_uraian = data.sub_unit_kerja ;


          this.form.date_usulan = data.date_usulan;

          this.form.pengoreksi = data.pengoreksi;
          this.form.status_koreksi = data.status_koreksi;
          this.form.date_koreksi = data.date_koreksi;

          this.form.harmonisuser = data.harmonisuser;
          this.form.status_harmonisasi = data.status_harmonisasi;
          this.form.date_harmonisasi = data.date_harmonisasi;


          this.form.pengusul_nama = data.pengusul_nama ;
          this.form.pengusul_gelar_belakang = data.pengusul_gelar_belakang ;
          this.form.pengusul_gelar_depan = data.pengusul_gelar_depan ;
          this.form.pengusul_nip = data.pengusul_nip ;

          this.form.pengoreksi_nama = data.pengoreksi_nama ;
          this.form.pengoreksi_gelar_belakang = data.pengoreksi_gelar_belakang ;
          this.form.pengoreksi_gelar_depan = data.pengoreksi_gelar_depan ;
          this.form.pengoreksi_nip = data.pengoreksi_nip ;

          this.form.harmonisasi_nama = data.harmonisasi_nama ;
          this.form.harmonisasi_gelar_belakang = data.harmonisasi_gelar_belakang ;
          this.form.harmonisasi_gelar_depan = data.harmonisasi_gelar_depan ;
          this.form.harmonisasi_nip = data.harmonisasi_nip ;



          
          this.fileOld = data.file ; 

          DATA_MASTER.getBiodataNip(data.nip)
          DATA_MASTER.getListLampiran(this.form.id )

      },


      addDataLampiran: function(){

        // fileRef : '',
        //   master_file : '',
        //   status : 1,

        var formData = new FormData();
        formData.append('fileRef', this.form.id);
        formData.append('uraian', this.lampiran.uraian);
        formData.append('status', 1);
        formData.append('file', this.lampiran.file);

        fetch(this.$store.state.url.URL_jdih_usulan+'addFileLampiran', {
            method: "POST",
            headers: {
                authorization : 'kikensbatara '+localStorage.token
            },
            body: formData
        }).then(res => res.json()).then((data_urusan) => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          DATA_MASTER.getListLampiran(this.form.id )
        });
      },

      removeDataLampiran : function(E){
        fetch(this.$store.state.url.URL_jdih_usulan + "removeLampiran", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({id : this.lampiran.id, file : this.fileOld})
        }).then(res_data => {
            this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
            DATA_MASTER.getListLampiran(this.form.id );
        });
  
      },

      selectDataFile : function(data){

          console.log(data);


          this.lampiran.id = data.id ; 
          this.fileOld = data.file ; 
          this.lampiran.fileRef = data.fileRef ; 
          this.lampiran.uraian = data.uraian ; 

          this.lampiran.file_id = data.file_id ; 
          this.lampiran.file_status = data.file_status ; 
          this.lampiran.file_keterangan = data.file_keterangan ; 
          this.lampiran.file_correction = data.file_correction ; 
          this.lampiran.keterangan = data.keterangan ; 

      },
  
      // ====================================== CONTOH eDOC ====================================
      onClickx(data){
        alert(data)
      },
      // ====================================== CONTOH eDOC ====================================
  
    // ====================================== CONTOH AUTOCOMPLETE ====================================
      autocomplete_db_filter : function (val, update) {
          update(() => {
            if (val === '') {}
            else { 
              console.log(val);
              DATA_MASTER.getBiodataSearch(this.filterku.unit_kerja, val);
            }
          })

          // update(() => {
          //   const needle = val.toLowerCase()
          //   this.$store.state.list_biodata = this.$store.state.list_biodata.filter(v => v.toLowerCase().indexOf(needle) > -1)
          // })
      },

      autocomplete_db_filter_unit : function (val, update) {
          update(() => {
            if (val === '') {}
            else { 
              console.log(val);
              DATA_MASTER.getUnitKerjaAuto(val);
            }
          })
          // update(() => {
          //   const needle = val.toLowerCase()
          //   this.$store.state.list_biodata = this.$store.state.list_biodata.filter(v => v.toLowerCase().indexOf(needle) > -1)
          // })
      },


     
  
      // ====================================== CONTOH AUTOCOMPLETE ====================================
  
  
  
  
  
  
  
  
      // ====================================== PAGINATE ====================================
          Notify : function(message, positive, icon){
            this.$q.notify({
              message: message,
              color: positive,
              icon: icon,
              position : 'top',
              timeout: 500,
            })
          },

          btn_prev : function(){
              this.cek_load_data = true;
              if(this.page_first>1){
                  this.page_first--
              }else{
                  this.page_first = 1;
              }
              this.getView();
          },
  
          btn_next : function(){
              if(this.page_first >= this.page_last){
                  this.page_first == this.page_last
              }else{
                  this.page_first++;
              }
              this.getView();
          },
  
          cari_data : function(){
              this.page_first = 1;
              this.getView();
          },
  
  
      // ====================================== PAGINATE ====================================
  
  
  
  
  
  
  
    },
  
    mounted () {
    //   FETCHING.getContohAtocomplete('')
      this.getView();

      var get_profile = JSON.parse(localStorage.profile);
      this.filterku.unit_kerja = get_profile.profile.unit_kerja;
      this.filterku.instansi = get_profile.profile.instansi_id;
      this.filterku.instansi = get_profile.profile.instansi_id;
      
      this.form.unit_kerja = get_profile.profile.unit_kerja;


    DATA_MASTER.getInstansi();
    DATA_MASTER.getUnitKerja(this.filterku.instansi);
    DATA_MASTER.getUnitKerjaAuto('');
    DATA_MASTER.getBiodata(this.filterku.unit_kerja);
    DATA_MASTER.getMasterKategori('')



    },
  }
